var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"app-header-contact",attrs:{"href":_vm.href}},[_c('IconPhoneOutline'),_vm._v("\n  "+_vm._s(_vm.$t('header.contact'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }